routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.reportPendientesItems', {
      url: "reportes/pendientes-items",
      template: `<report-pendientes-items sh-ctrl="shCtrl"></report-pendientes-items>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/reports/pendientesItems/pendientes-items.config.js
 **/